import "./runtimeEnvironment-D1yr0yUs.mjs";
import { n as deprecatedObjectProperty, r as deprecatedProperty, t as deprecated } from "./deprecated--jK9xTNh.mjs";

export { deprecated, deprecatedObjectProperty, deprecatedProperty };